import React from "react";
import PropTypes from "prop-types";
import Section from "./common/Section";
import IconGroup from "./common/icon/IconGroup";
import { Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bgWhiteIcons } from "./data/socialIcons";
import { useTranslation } from "react-i18next";

const FooterTitle = ({ children }) => (
  <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
);

FooterTitle.propTypes = { children: PropTypes.node.isRequired };

const FooterStandard = () => {
  const { t } = useTranslation();

  // UPDATED: Logic to handle both internal and external navigation
  const moveToPath = (e, path) => {
    if (path.startsWith("http")) {
      // If it's an external link, let the browser handle the target="_blank"
      // or manually trigger window.open if you must use JS.
      return;
    }
    e.preventDefault();
    window.location.href = path;
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const linkHeadings = [
    "OUR MISSION",
    "OUR COMPANY",
    "KEY FEATURES",
    "USEFFUL LINKS",
  ];

  const links = {
    company: [
      { label: "Home", to: "/" },
      { label: "About", to: "/about-condozak" },
      { label: "Integrations", to: "/#acc-integ" },
      { label: "Pricing", to: "/pricing" },
      { label: "Contact Us", to: "/contact-us" },
      { label: "Terms", to: "/terms-and-conditions" },
      { label: "Privacy Policy", to: "/privacy-policy" },
    ],
    features: [
      { label: "E-Consent Management", to: "/announcements" },
      { label: "Property Accounting", to: "/property-accounting" },
      { label: "Vendor Management", to: "/vendor-management" },
      { label: "Budget Mail-Outs", to: "/announcements" },
      { label: "Maintenance Requests", to: "/maintenance-requests" },
      { label: "Violation Tracking", to: "/violations-tracking" },
      { label: "Document Drive", to: "/document-drive" }
    ],
    links: [
      {
        label: "Landlord and Tenant Board",
        to: "https://tribunalsontario.ca/ltb/",
      },
      {
        label: "The Association of Condominium Managers of Ontario",
        to: "https://www.acmo.org/",
      },
      {
        label: "Condominium Authority of Ontario",
        to: "https://www.condoauthorityontario.ca/",
      },
    ],
  };

  return (
    <>
      <Section bg="dark" className="pt-5 pb-4 light position-relative">
        <div
          className="position-fixed d-none d-md-flex justify-content-center align-items-center bg-dark p-2 rounded-circle shadow"
          onClick={scrollToTop}
          style={{
            right: "20px",
            bottom: "20px",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            zIndex: 1050,
          }}
        >
          <FontAwesomeIcon icon="chevron-up" className="text-white" />
        </div>

        <Container>
          <Row>
            <Col xs={12} lg={4} className="mb-4">
              <FooterTitle>{t("footer.our_mission")}</FooterTitle>
              <p className="text-600">{t("footer.para_1")}</p>
              <IconGroup className="mt-4" icons={bgWhiteIcons} />
            </Col>

            <Col xs={12} lg={8}>
              <Row>
                {Object.entries(links).map(([key, items], index) => (
                  <Col xs={12} sm={6} md={4} key={key} className="mb-4">
                    <FooterTitle>{linkHeadings[index + 1]}</FooterTitle>
                    <ul className="list-unstyled">
                      {items.map((item, i) => {
                        // Check if the link is external
                        const isExternal = item.to.startsWith("http");

                        return (
                          <li key={`${key}-${i}`} className="mt-2">
                            <a
                              href={item.to}
                              className="text-secondary"
                              // UPDATED: Added target and rel for external links
                              target={isExternal ? "_blank" : "_self"}
                              rel={isExternal ? "noopener noreferrer" : undefined}
                              onClick={(e) => moveToPath(e, item.to)}
                            >
                              {item.label}
                              <br />
                              <span className="text-white">
                                {linkHeadings[index + 1] === "USEFFUL LINKS" &&
                                  item.to}
                              </span>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </Section>

      {/* Bottom Strip remains unchanged */}
      <section className="bg-dark text-center py-3">
        <hr className="my-0 border-600 opacity-25" />
        <Container>
          <Row className="justify-content-center">
            <Col xs={12}>
              <p className="mb-0 text-600 mt-2 small">
                CONDOZAK™ is a product of{" "}
                <a
                  className="text-white opacity-85 ms-1"
                  href="https://www.truzak.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Truzak Technology Inc.
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FooterStandard;

// import React from "react";
// import PropTypes from "prop-types";
// import Section from "./common/Section";
// import IconGroup from "./common/icon/IconGroup";
// import { Row, Col, Container } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { bgWhiteIcons } from "./data/socialIcons";
// import { useTranslation } from "react-i18next";

// const FooterTitle = ({ children }) => (
//   <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
// );

// FooterTitle.propTypes = { children: PropTypes.node.isRequired };

// const FooterStandard = () => {
//   const { t } = useTranslation();

//   const moveToPath = (path) => {
//     window.location.href = path;
//   };

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
//   };

//   const links = {
//     company: [
//       { label: "Home", to: "/" },
//       { label: "About", to: "/about-condozak" },
//       { label: "Integrations", to: "/#acc-integ" },
//       { label: "Pricing", to: "/pricing" },
//       { label: "Contact Us", to: "/contact-us" },
//       { label: "Terms", to: "/terms-and-conditions" },
//       { label: "Privacy Policy", to: "/privacy-policy" },
//     ],
//     features: [
//       { label: "E-Consent Management", to: "/amenity-bookings" },
//       { label: "Budget Mail-Outs", to: "/announcements" },
//       { label: "Maintenance Requests", to: "/maintenance-requests" },
//       { label: "Violation Tracking", to: "/violations-tracking" },
//       { label: "Document Drive", to: "/document-drive" },
//       { label: "Bulletin Board", to: "/bulletin-board" },
//       { label: "Events Calendar", to: "/events-calendar" },
//     ],
//     links: [
//       {
//         label: "Landlord and Tenant Board",
//         to: "https://tribunalsontario.ca/ltb/",
//       },
//       {
//         label: "The Association of Condominium Managers of Ontario",
//         to: "https://www.acmo.org/",
//       },
//       {
//         label: "Condominium Authority of Ontario",
//         to: "https://www.condoauthorityontario.ca/",
//       },
//     ],
//   };

//   return (
//     <>
//       <Section bg="dark" className="pt-8 pb-4 light">
//         <div
//           className="position-absolute btn-back-to-top cursor-pointer bg-dark p-2 rounded"
//           onClick={scrollToTop}
//           style={{ right: "20px", bottom: "20px" }}
//         >
//           <FontAwesomeIcon icon="chevron-up" className="text-600" />
//         </div>
//         <Container>
//           <Row>
//             <Col lg={4} className="mb-4">
//               <FooterTitle>{t("footer.our_mission")}</FooterTitle>
//               <p className="text-600">{t("footer.para_1")}</p>
//               <IconGroup className="mt-4" icons={bgWhiteIcons} />
//             </Col>
//             <Col lg={8}>
//               <Row>
//                 {Object.entries(links).map(([key, items], index) => (
//                   <Col key={key} xs={6} md={4} className="mb-4">
//                     {/* <FooterTitle>{t(`footer.${key}`)}</FooterTitle> */}
//                     <FooterTitle>{`${key}`}</FooterTitle>
//                     <ul className="list-unstyled">
//                       {items.map((item, i) => (
//                         <li key={`${key}-${i}`} className="mt-3">
//                           <a
//                             href={item.to}
//                             className="text-secondary"
//                             onClick={() => moveToPath(item.to)}
//                           >
//                             {item.label}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </Col>
//                 ))}
//               </Row>
//             </Col>
//           </Row>
//         </Container>
//       </Section>

//       <section className="bg-dark text-center py-3">
//         <hr className="my-0 border-600 opacity-25" />
//         <Container>
//           <Row className="justify-content-center">
//             <Col xs={12}>
//               <p className="mb-0 text-600 mt-2">
//                 CONDOZAK™ is a product of
//                 <a
//                   className="text-white opacity-85 ms-1"
//                   href="https://www.truzak.com/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Truzak Technology Inc.
//                 </a>
//               </p>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default FooterStandard;

// import React from "react";
// import PropTypes from "prop-types";
// import Section from "./common/Section";
// import IconGroup from "./common/icon/IconGroup";
// import { Row, Col } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { bgWhiteIcons } from "./data/socialIcons";
// import { useTranslation } from "react-i18next";

// const FooterTitle = ({ children }) => (
//   <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
// );

// FooterTitle.propTypes = { children: PropTypes.node.isRequired };

// const FooterStandard = () => {
//   const moveToPath = (path) => {
//     window.location.href = path;
//   };

//   let forCompany = [
//     {
//       label: "Home",
//       to: "/",
//     },
//     {
//       label: "About",
//       to: "/about-condozak",
//     },
//     {
//       label: "Integrations",
//       to: "/#acc-integ",
//     },
//     {
//       label: "Pricing",
//       to: "/pricing",
//     },
//     {
//       label: "Contact Us",
//       to: "/contact-us",
//     },
//     {
//       label: "Terms",
//       to: "/terms-and-conditions",
//     },
//     {
//       label: "Privacy Policy",
//       to: "/privacy-policy",
//     },
//   ];

//   let forFeatures = [
//     {
//       label: "E-Consent Management",
//       to: "/amenity-bookings",
//     },
//     {
//       label: "Budget Mail-Outs",
//       to: "/announcements",
//     },
//     {
//       label: "Maintenance Requests",
//       to: "/maintenance-requests",
//     },
//     {
//       label: "Violation Tracking",
//       to: "/violations-tracking",
//     },
//     {
//       label: "Document Drive",
//       to: "/document-drive",
//     },
//     {
//       label: "Bulletin Board",
//       to: "/violations-tracking",
//     },
//     {
//       label: "Events Calendar",
//       to: "/document-drive",
//     },
//   ];

//   let forBlog = [
//     {
//       label: "Landlord and Tenant Board",
//       to: "https://tribunalsontario.ca/ltb/",
//     },
//     {
//       label: "The Association of Condominium Managers of Ontario",
//       to: "https://www.acmo.org/",
//     },
//     {
//       label: "Condominium Authority of Ontario",
//       to: "https://www.condoauthorityontario.ca/",
//     },
//   ];

//   const { t } = useTranslation();

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   };
//   return (
//     <>
//       <Section bg="dark" className="pt-8 pb-4 light">
//         <div
//           className="position-absolute btn-back-to-top cursor-pointer bg-dark"
//           onClick={scrollToTop}
//         >
//           <FontAwesomeIcon
//             icon="chevron-up"
//             transform="rotate-45"
//             className="text-600"
//           />
//         </div>
//         <Row>
//           <Col lg={4}>
//             <FooterTitle>{t("footer.our_mission")}</FooterTitle>
//             <p className="text-600">{t("footer.para_1")}</p>
//             <IconGroup className="mt-4" icons={bgWhiteIcons} />
//           </Col>
//           <Col className="ps-lg-6 ps-xl-8">
//             <Row className="mt-5 mt-lg-0">
//               <Col xs={6} md={3}>
//                 <FooterTitle>{t("footer.company")}</FooterTitle>
//                 <ul className="list-unstyled">
//                   {forCompany?.map((v, i) => (
//                     <li
//                       key={i + "23456"}
//                       className="cursor-pointer"
//                       style={{ marginTop: "9px" }}
//                     >
//                       <a
//                         href={v.to}
//                         className="text-secondary"
//                         onClick={() => moveToPath(v.to)}
//                       >
//                         {v.label}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>
//               </Col>
//               <Col xs={6} md={3}>
//                 <FooterTitle>Key Features</FooterTitle>
//                 <ul className="list-unstyled">
//                   {forFeatures?.map((v, i) => (
//                     <li
//                       key={i + "234931"}
//                       className="cursor-pointer"
//                       style={{ marginTop: "10px" }}
//                     >
//                       <a
//                         href={v.to}
//                         className="text-secondary"
//                         onClick={() => moveToPath(v.to)}
//                         style={{ fontSize: "15px" }}
//                       >
//                         {v.label}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>
//               </Col>
//               <Col xs={6} md={3} className="mt-5 mt-md-0">
//                 <FooterTitle>USEFUL LINKS</FooterTitle>
//                 <ul className="list-unstyled">
//                   {forBlog?.map((v, i) => (
//                     <li
//                       key={i + "847"}
//                       className="cursor-pointer"
//                       style={{ width: "300px", marginTop: "25px" }}
//                     >
//                       {v.label}
//                       <br />

//                       <a
//                         className="text-white opacity-85"
//                         href={v.to}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {v.to}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//       </Section>

//       <section className=" bg-dark py-0 text-center fs--1 light">
//         <hr className="my-0 border-600 opacity-25" />
//         <div className="container py-3">
//           <Row className="justify-content-between align-content-center">
//             <Col xs={12} md={12} sm="auto" className="text-center">
//               <p className=" mb-0 text-600">
//                 CONDOZAK™ is a product of
//                 <a
//                   className="text-white opacity-85 ms-1"
//                   href="https://www.truzak.com/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Truzak Technology Inc.
//                 </a>
//               </p>
//             </Col>
//           </Row>
//         </div>
//       </section>
//     </>
//   );
// };

// export default FooterStandard;
